import React, { useEffect, useMemo, useState } from "react";
import { Accordion, ActionDropdown, IconButton } from 'components/common';
import TinymceEditor from "components/common/TinymceEditor";
import BDSGeneralInformation from "./BDSGeneralInformation";
import Select from "react-select";
import PropTypes from 'prop-types';
import { FaEdit, FaPlus, FaTrashAlt } from "react-icons/fa";
import { INPUT_CLS, TEXTAREA_CLS, SELECT_STYLES, CHECK_CLS, TH_CLS, TD_CLS, SECTION_BODY_CLS, VALUE_CLS } from "../../pifStyles";

import {
  CRM_PIF_LOADS_RECURRENCE_TIME,
  CRM_PIF_LOADS_EXPLOSURE,
  CRM_PIF_LOADS_OCCUPANCYCATEGORY,
  CRM_PIF_GRADE_PRIMARY_MEMBER,
  CRM_PIF_GRADE_SECONDARY_MEMBER,
  CRM_PIF_BUILDING_FRAME_TYPE,
  CRM_PIF_BUILDING_HEIGHT,
  CRM_PIF_BUILDING_COLUMN_SUPPORT,
  CRM_PIF_WALL_FRAME,
  CRM_PIF_GIRT_TYPE,
  CRM_PIF_ROOF_PROFILE,
  CRM_PIF_COLOR,
  CRM_PIF_ROOF_NAME
} from "app_config";
import { useSelector } from "react-redux";

const CHECK_LABEL_CLS = "tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-select-none";

const BDS1 = ({
  data,
  openWallData,
  newOpenWall,
  editOpenWall,
  deleteOpenWall
}) => {
  const {bds1: initialKeys} = useSelector(state => state.crm_project_pif.initialKeys);
  const [activeKey, setActiveKey] = useState(initialKeys);

  const {project, building, area} = data;
  const {control, register, Controller, setValue} = data.useHookForm;

  const areaId = area.id
  const {bds1} = area

  useEffect(() => {
    setActiveKey(initialKeys);
  }, [initialKeys]);

  useEffect(() => {
    if (bds1) {
      Object.entries(bds1).forEach(([key, value]) => {
        setValue(`bds1_${key}_${area.id}`, value)
      })
    }
  }, [bds1, setValue, area.id]);

  const loadsRecurrenceTimeOptions = useMemo(() => (
    CRM_PIF_LOADS_RECURRENCE_TIME.map((option) => ({value: option, label: option}))
  ), [])
  const defaultLoadsRecurrenceTimeOption = bds1 ? { value: bds1.loads_recurrence_time, label: bds1.loads_recurrence_time } : null

  const loadsExplosureOptions = useMemo(() => (
    CRM_PIF_LOADS_EXPLOSURE.map((option) => ({value: option, label: option}))
  ), [])
  const defaultLoadsExplosureOption = bds1 ? { value: bds1.loads_explosure, label: bds1.loads_explosure } : null

  const loadsOccupancyCategoryOptions = useMemo(() => (
    CRM_PIF_LOADS_OCCUPANCYCATEGORY.map((option) => ({value: option, label: option}))
  ), [])
  const defaultLoadsOccupancyCategoryOption = bds1 ? { value: bds1.loads_occupancy_category, label: bds1.loads_occupancy_category } : null

  const gradePrimaryMemberOptions = useMemo(() => (
    CRM_PIF_GRADE_PRIMARY_MEMBER.map((option) => ({value: option, label: option}))
  ), [])
  const defaultGradePrimaryMemberOption = bds1 ? { value: bds1.grade_primary_member, label: bds1.grade_primary_member } : null

  const gradeSecondaryMemberOptions = useMemo(() => (
    CRM_PIF_GRADE_SECONDARY_MEMBER.map((option) => ({value: option, label: option}))
  ), [])
  const defaultGradeSecondaryMemberOption = bds1 ? { value: bds1.grade_secondary_member, label: bds1.grade_secondary_member } : null

  const frameTypeOptions = useMemo(() => (
    CRM_PIF_BUILDING_FRAME_TYPE.map((option) => ({value: option, label: option}))
  ), [])
  const defaultFrameTypeOption = bds1 ? { value: bds1.building_parameters_frame_type, label: bds1.building_parameters_frame_type } : null

  const buildingHeightOptions = useMemo(() => (
    CRM_PIF_BUILDING_HEIGHT.map((option) => ({value: option, label: option}))
  ), [])
  const defaultBuildingHeightOption = bds1 ? { value: bds1.building_parameters_height, label: bds1.building_parameters_height } : null

  const buildingColumnSupportOptions = useMemo(() => (
    CRM_PIF_BUILDING_COLUMN_SUPPORT.map((option) => ({value: option, label: option}))
  ), [])
  const defaultBuildingColumnSupportOption = bds1 ? { value: bds1.building_parameters_column_support, label: bds1.building_parameters_column_support } : null

  const wallFrameOptions = useMemo(() => (
    CRM_PIF_WALL_FRAME.map((option) => ({value: option, label: option}))
  ), [])
  const defaultLeftEndWallFrameOption = bds1 ? { value: bds1.left_end_wall_frame, label: bds1.left_end_wall_frame } : null
  const defaultRightWallFrameOption = bds1 ? { value: bds1.right_end_wall_frame, label: bds1.right_end_wall_frame } : null

  const girtTypeOptions = useMemo(() => (
    CRM_PIF_GIRT_TYPE.map((option) => ({value: option, label: option}))
  ), [])
  const defaultLeftGirtTypeOption = bds1 ? { value: bds1.lef_end_girt_type, label: bds1.lef_end_girt_type } : null
  const defaultNearGirtTypeOption = bds1 ? { value: bds1.near_site_girt_type, label: bds1.near_site_girt_type } : null
  const defaultRightGirtTypeOption = bds1 ? { value: bds1.right_end_girt_type, label: bds1.right_end_girt_type } : null
  const defaultFarGirtTypeOption = bds1 ? { value: bds1.far_side_girt_type, label: bds1.far_side_girt_type } : null

  const roofProfileOptions = useMemo(() => (
    CRM_PIF_ROOF_PROFILE.map((option) => ({value: option, label: option}))
  ), [])
  const defaultRoofProfileOption = bds1 ? { value: bds1.roof_profile, label: bds1.roof_profile } : null
  const defaultWallProfileOption = bds1 ? { value: bds1.wall_profile, label: bds1.wall_profile } : null

  const colorOptions = useMemo(() => (
    CRM_PIF_COLOR.map((option) => ({value: option, label: option}))
  ), [])
  const defaultRoofColorOption = bds1 ? { value: bds1.roof_color, label: bds1.roof_color } : null
  const defaultWallColorOption = bds1 ? { value: bds1.wall_color, label: bds1.wall_color } : null
  const defaultWallTrimColorGutterOption = bds1 ? { value: bds1.wall_trim_colors, label: bds1.wall_trim_colors } : null
  const defaultWallTrimColorOtherOption = bds1 ? { value: bds1.wall_trim_colors_others, label: bds1.wall_trim_colors_others } : null

  const roofInsulationOptions = useMemo(() => (
    CRM_PIF_ROOF_NAME.map((option) => ({value: option, label: option}))
  ), [])
  const defaultRoofNameOption = bds1 ? { value: bds1.roof_name, label: bds1.roof_name } : null
  const defaultWallNameOption = bds1 ? { value: bds1.wall_name, label: bds1.wall_name } : null

  const handleAccordionSelect = (newActiveKey) => {
    setActiveKey(newActiveKey)
  }

  return (
    <Accordion
      activeKeys={activeKey}
      onChange={handleAccordionSelect}
      className="tw-text-sm"
    >
      <Accordion.Item eventKey="0" header="1. General Information">
        <div className={SECTION_BODY_CLS}>
          <BDSGeneralInformation data={data} />
          <h6 className="tw-text-center tw-my-2">This area only : Page 1 of 3</h6>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-1 tw-mb-2 tw-mt-4">
            <div className="tw-col-span-5">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2">
                <div className="tw-col-span-4">Customer name:</div>
                <div className={`tw-col-span-8 tw-font-semibold ${VALUE_CLS}`}>{project?.customer?.name}</div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2">
                <div className="tw-col-span-4">Project name:</div>
                <div className={`tw-col-span-8 tw-font-semibold ${VALUE_CLS}`}>{project?.name}</div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Building usage:</div>
                <div className="tw-col-span-8 tw-font-semibold">
                  <input
                    placeholder="Building usage"
                    className={INPUT_CLS}
                    {...register(`bds1_building_usage_${area.id}`)}
                  />
                </div>
              </div>
            </div>
            <div className="tw-col-span-7">
              <div className="tw-flex tw-gap-x-1 tw-mb-2">
                <div>Location:</div>
                <div className={`tw-flex-1 tw-font-semibold ${VALUE_CLS}`}>{building?.pj_location}</div>
              </div>
              <div className="tw-flex tw-gap-x-1 tw-mb-2 tw-items-center">
                <div>Qty of Identical Bldgs:</div>
                <div className="tw-flex-1 tw-font-semibold">
                  <input
                    type="number"
                    placeholder="Qty of Identical Bldgs"
                    className={INPUT_CLS}
                    {...register(`bds1_qty_of_identical_bldgs_${area.id}`)}
                  />
                </div>
              </div>
              <div className="tw-flex tw-gap-x-1 tw-mb-2 tw-items-center">
                <div>Estimated No. of trailers/ containers for all identical bldgs:</div>
                <div className="tw-flex-1 tw-font-semibold">
                  <input
                    type="number"
                    placeholder="Estimated No. of trailers"
                    className={INPUT_CLS}
                    {...register(`bds1_estimated_no_trailed_${area.id}`)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Accordion.Item>

{/* 2. Loads (kN/m2) */}
      <Accordion.Item eventKey="1" header="2. Loads (kN/m2)">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-2">
            <div className="tw-col-span-5">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-0 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">Live (On Purlins):</div>
                <div className="tw-col-span-7">
                  <div className="tw-flex">
                    <input
                      placeholder="Live (On Purlins)"
                      className={INPUT_CLS}
                      {...register(`bds1_loads_live_on_purlins_${area.id}`)}
                    />
                    <div className="tw-ml-1">(KN/m2)</div>
                  </div>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-0 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">On Frames:</div>
                <div className="tw-col-span-7">
                  <div className="tw-flex">
                    <input
                      placeholder="On Frames"
                      className={INPUT_CLS}
                      {...register(`bds1_loads_on_frame_${area.id}`)}
                    />
                    <div className="tw-ml-1">(KN/m2)</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">Collateral on Frame:</div>
                <div className="tw-col-span-7">
                  <div className="tw-flex">
                    <input
                      placeholder="Collateral on Frame"
                      className={INPUT_CLS}
                      {...register(`bds1_loads_collateral_on_frame_${area.id}`)}
                    />
                    <div className="tw-ml-1">(KN/m2)</div>
                  </div>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">Collateral on Roof:</div>
                <div className="tw-col-span-7">
                  <div className="tw-flex">
                    <input
                      placeholder="Collateral on Roof"
                      className={INPUT_CLS}
                      {...register(`bds1_loads_collateral_on_roof_${area.id}`)}
                    />
                    <div className="tw-ml-1">(KN/m2)</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tw-col-span-2">
              <div className="tw-mt-3">
                <Controller
                  control={control}
                  name={`bds1_loads_seismic_${area.id}`}
                  render={({ field }) => (
                    <label className={CHECK_LABEL_CLS}>
                      <input
                        type="checkbox"
                        className={CHECK_CLS}
                        checked={!!field.value}
                        onChange={(value) => field.onChange(value)}
                      />
                      <span>Seismic</span>
                    </label>
                  )}
                />
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-x-4 tw-mb-2 tw-items-center">
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-0 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">Wind Speed (KMH):</div>
                <div className="tw-col-span-7">
                  <input
                    placeholder="Wind Speed (KMH)"
                    className={INPUT_CLS}
                    {...register(`bds1_loads_wind_speed_${area.id}`)}
                  />
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-0 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">Recurrence time:</div>
                <div className="tw-col-span-7">
                  <Controller
                    control={control}
                    name={`bds1_loads_recurrence_time_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={loadsRecurrenceTimeOptions}
                        defaultValue={defaultLoadsRecurrenceTimeOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        onChange={selectedOption => setValue(`bds1_loads_recurrence_time_${area.id}`, selectedOption.value, {shouldValidate: true})}
                      />
                    )}
                  />

                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-2 tw-items-center">
                <div className="tw-col-span-3">Explosure:</div>
                <div className="tw-col-span-9">
                  <Controller
                    control={control}
                    name={`bds1_loads_explosure_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={loadsExplosureOptions}
                        defaultValue={defaultLoadsExplosureOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_loads_explosure_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-2 tw-items-center">
                <div className="tw-col-span-3">Rainfall:</div>
                <div className="tw-col-span-9">
                  <div className="tw-flex tw-items-center">
                    <input
                      placeholder="Rainfall"
                      className={INPUT_CLS}
                      {...register(`bds1_loads_rainfall_${area.id}`)}
                    />
                    <div className="tw-ml-1">mm/hr</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-x-2 tw-mb-2 tw-items-center">
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-x-2 tw-mb-2 tw-items-center">
                <div>Description of collateral load:</div>
                <div className="tw-flex-1">
                  <input
                    placeholder="Description of collateral load"
                    className={INPUT_CLS}
                    {...register(`bds1_loads_description_${area.id}`)}
                  />
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-x-2 tw-mb-2 tw-items-center">
                <div>Occupancy category:</div>
                <div className="tw-flex-1">
                  <Controller
                    control={control}
                    name={`bds1_loads_occupancy_category_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={loadsOccupancyCategoryOptions}
                        defaultValue={defaultLoadsOccupancyCategoryOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_loads_occupancy_category_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4">
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-x-2">
                <div className="tw-font-semibold">Building Code:</div>
                <div className="tw-flex-1">
                  <div className="tw-flex tw-justify-between">
                    <Controller
                      control={control}
                      name={`bds1_loads_building_code_mbma_2012_${area.id}`}
                      render={({ field }) => (
                        <label className={CHECK_LABEL_CLS}>
                          <input
                            type="checkbox"
                            className={CHECK_CLS}
                            checked={!!field.value}
                            onChange={(value) => field.onChange(value)}
                          />
                          <span>MBMA 2012</span>
                        </label>
                      )}
                    />
                    <Controller
                      control={control}
                      name={`bds1_loads_building_code_ibc_2018_${area.id}`}
                      render={({ field }) => (
                        <label className={CHECK_LABEL_CLS}>
                          <input
                            type="checkbox"
                            className={CHECK_CLS}
                            checked={!!field.value}
                            onChange={(value) => field.onChange(value)}
                          />
                          <span>IBC 2018</span>
                        </label>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="tw-col-span-7">
              <div className="tw-flex tw-gap-x-2">
                <div className="tw-font-semibold">Design Standard:</div>
                <div className="tw-flex-1">
                  <div className="tw-flex tw-justify-between">
                    <Controller
                      control={control}
                      name={`bds1_loads_design_standard_aisc_asd89_${area.id}`}
                      render={({ field }) => (
                        <label className={CHECK_LABEL_CLS}>
                          <input
                            type="checkbox"
                            className={CHECK_CLS}
                            checked={!!field.value}
                            onChange={(value) => field.onChange(value)}
                          />
                          <span>AISC-ASD89</span>
                        </label>
                      )}
                    />
                    <Controller
                      control={control}
                      name={`bds1_loads_design_standard_aisc_360_16_${area.id}`}
                      render={({ field }) => (
                        <label className={CHECK_LABEL_CLS}>
                          <input
                            type="checkbox"
                            className={CHECK_CLS}
                            checked={!!field.value}
                            onChange={(value) => field.onChange(value)}
                          />
                          <span>AISC360-16</span>
                        </label>
                      )}
                    />
                    <Controller
                      control={control}
                      name={`bds1_loads_design_standard_aisi_2001_${area.id}`}
                      render={({ field }) => (
                        <label className={CHECK_LABEL_CLS}>
                          <input
                            type="checkbox"
                            className={CHECK_CLS}
                            checked={!!field.value}
                            onChange={(value) => field.onChange(value)}
                          />
                          <span>AISI 2001</span>
                        </label>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-flex tw-gap-x-2">
            <div className="tw-flex-1">
              <Controller
                control={control}
                name={`bds1_loads_building_code_others_${area.id}`}
                render={({ field }) => (
                  <TinymceEditor rollback={false}
                    height="40vh"
                    handleChange={field.onChange}
                    value={field.value}
                  />
                )}
              />
            </div>
            <div className="tw-flex-1">
              <Controller
                control={control}
                name={`bds1_loads_design_standard_others_${area.id}`}
                render={({ field }) => (
                  <TinymceEditor rollback={false}
                    height="40vh"
                    handleChange={field.onChange}
                    value={field.value}
                  />
                )}
              />
            </div>
          </div>
        </div>
      </Accordion.Item>

{/* 3. Grade (kN/m2) */}
      <Accordion.Item eventKey="2" header="3. Grade (kN/m2)">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
            <div className="tw-col-span-3">Primary member:</div>
            <div className="tw-col-span-9">
              <Controller
                control={control}
                name={`bds1_grade_primary_member_${area.id}`}
                render={() => (
                  <Select
                    closeMenuOnSelect={true}
                    options={gradePrimaryMemberOptions}
                    defaultValue={defaultGradePrimaryMemberOption}
                    placeholder='Select...'
                    styles={SELECT_STYLES}
                    onChange={selectedOption => setValue(`bds1_grade_primary_member_${area.id}`, selectedOption.value, {shouldValidate: true})}
                  />
                )}
              />
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
            <div className="tw-col-span-3">Secondary member:</div>
            <div className="tw-col-span-9">
              <Controller
                control={control}
                name={`bds1_grade_secondary_member_${area.id}`}
                render={() => (
                  <Select
                    closeMenuOnSelect={true}
                    options={gradeSecondaryMemberOptions}
                    defaultValue={defaultGradeSecondaryMemberOption}
                    placeholder='Select...'
                    styles={SELECT_STYLES}
                    onChange={selectedOption => setValue(`bds1_grade_secondary_member_${area.id}`, selectedOption.value, {shouldValidate: true})}
                  />
                )}
              />
            </div>
          </div>
          <div>
            <textarea
              rows={5}
              placeholder="Specify note..."
              className={TEXTAREA_CLS}
              {...register(`bds1_grade_note_${area.id}`)}
            />
          </div>
        </div>
      </Accordion.Item>

{/* 4. Building Parameters */}
      <Accordion.Item eventKey="3" header="4. Building Parameters">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2">
            <div className="tw-col-span-4">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Frame Type:</div>
                <div className="tw-col-span-8">
                  <Controller
                    control={control}
                    name={`bds1_building_parameters_frame_type_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={frameTypeOptions}
                        defaultValue={defaultFrameTypeOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_building_parameters_frame_type_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="tw-col-span-3">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-3">Slope:</div>
                <div className="tw-col-span-9">
                  <input
                    placeholder="Slope"
                    className={INPUT_CLS}
                    {...register(`bds1_building_parameters_slope_${area.id}`)}
                  />
                </div>
              </div>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-3">Height (M):</div>
                <div className="tw-col-span-9">
                  <div className="tw-grid tw-grid-cols-12 tw-gap-x-1">
                    <div className="tw-col-span-6">
                      <input
                        placeholder="Height (M)"
                        className={INPUT_CLS}
                        {...register(`bds1_building_parameters_height_other_${area.id}`)}
                      />
                    </div>
                    <div className="tw-col-span-6">
                      <Controller
                        control={control}
                        name={`bds1_building_parameters_height_${area.id}`}
                        render={() => (
                          <Select
                            closeMenuOnSelect={true}
                            options={buildingHeightOptions}
                            defaultValue={defaultBuildingHeightOption}
                            placeholder='Select...'
                            styles={SELECT_STYLES}
                            onChange={selectedOption => setValue(`bds1_building_parameters_height_${area.id}`, selectedOption.value, {shouldValidate: true})}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-x-4 tw-mb-2">
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Bldg Width (M):</div>
                <div className="tw-col-span-8">
                  <input
                    placeholder="Bldg Width (M)"
                    className={INPUT_CLS}
                    {...register(`bds1_building_parameters_bldgs_width_${area.id}`)}
                  />
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Width modules:</div>
                <div className="tw-col-span-8">
                  <input
                    placeholder="Width modules"
                    className={INPUT_CLS}
                    {...register(`bds1_building_parameters_width_module_${area.id}`)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-0 tw-mb-3 tw-items-center">
            <div className="tw-col-span-2">Length (M):</div>
            <div className="tw-col-span-10">
              <input
                placeholder="Length (M)"
                className={INPUT_CLS}
                {...register(`bds1_building_parameters_length_${area.id}`)}
              />
            </div>
          </div>
          <div className="tw-flex tw-gap-x-4 tw-mb-2">
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Bay Spacing (M):</div>
                <div className="tw-col-span-8">
                  <input
                    placeholder="Bay Spacing (M)"
                    className={INPUT_CLS}
                    {...register(`bds1_building_parameters_bay_spacing_${area.id}`)}
                  />
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Columns support:</div>
                <div className="tw-col-span-8">
                  <Controller
                    control={control}
                    name={`bds1_building_parameters_column_support_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={buildingColumnSupportOptions}
                        defaultValue={defaultBuildingColumnSupportOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        onChange={selectedOption => setValue(`bds1_building_parameters_column_support_${area.id}`, selectedOption.value, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="tw-mt-2">
            <Controller
              control={control}
              name={`bds1_building_parameters_note_${area.id}`}
              render={({ field }) => (
                <TinymceEditor rollback={false}
                  height="30vh"
                  handleChange={field.onChange}
                  value={field.value}
                />
              )}
            />
          </div>
        </div>
      </Accordion.Item>

{/* 5. Endwall Condition */}
      <Accordion.Item eventKey="4" header="5. Endwall Condition">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-flex tw-gap-x-4 tw-mb-2">
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Left End Wall Frame:</div>
                <div className="tw-col-span-8">
                  <Controller
                    control={control}
                    name={`bds1_left_end_wall_frame_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={wallFrameOptions}
                        defaultValue={defaultLeftEndWallFrameOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_left_end_wall_frame_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Right End Wall Frame:</div>
                <div className="tw-col-span-8">
                  <Controller
                    control={control}
                    name={`bds1_right_end_wall_frame_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={wallFrameOptions}
                        defaultValue={defaultRightWallFrameOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_right_end_wall_frame_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Left End Girt type:</div>
                <div className="tw-col-span-8">
                  <Controller
                    control={control}
                    name={`bds1_lef_end_girt_type_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={girtTypeOptions}
                        defaultValue={defaultLeftGirtTypeOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_lef_end_girt_type_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Near Side Girt type:</div>
                <div className="tw-col-span-8">
                  <Controller
                    control={control}
                    name={`bds1_near_site_girt_type_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={girtTypeOptions}
                        defaultValue={defaultNearGirtTypeOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_near_site_girt_type_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Wind Col. Spacing (M):</div>
                <div className="tw-col-span-8">
                  <input
                    placeholder="Wind Col. Spacing (M)"
                    className={INPUT_CLS}
                    {...register(`bds1_wind_col_spacing_left_${area.id}`)}
                  />
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Wind Col. Spacing (M):</div>
                <div className="tw-col-span-8">
                  <input
                    placeholder="Wind Col. Spacing (M)"
                    className={INPUT_CLS}
                    {...register(`bds1_wind_col_spacing_right_${area.id}`)}
                  />
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Right End Girt type:</div>
                <div className="tw-col-span-8">
                  <Controller
                    control={control}
                    name={`bds1_right_end_girt_type_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={girtTypeOptions}
                        defaultValue={defaultRightGirtTypeOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_right_end_girt_type_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Far Side Girt type:</div>
                <div className="tw-col-span-8">
                  <Controller
                    control={control}
                    name={`bds1_far_side_girt_type_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={girtTypeOptions}
                        defaultValue={defaultFarGirtTypeOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_far_side_girt_type_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="tw-mt-2">
            <Controller
              control={control}
              name={`bds1_endwall_condition_note_${area.id}`}
              render={({ field }) => (
                <TinymceEditor rollback={false}
                  height="30vh"
                  handleChange={field.onChange}
                  value={field.value}
                />
              )}
            />
          </div>
        </div>
      </Accordion.Item>

{/*6. Open walls lengths are measured from corner of NSW & LEW  */}
      <Accordion.Item eventKey="5" header="6. Open walls lengths are measured from corner of NSW & LEW">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-flex tw-justify-end">
            <IconButton
              size="sm"
              icon={<FaPlus size={12} />}
              className="tw-mr-1"
              onClick={() => newOpenWall(areaId)}
            >
              <span className="tw-hidden xl:tw-inline-block tw-ml-1">New Open Wall</span>
            </IconButton>
          </div>

          <div className="tw-overflow-x-auto tw-text-sm tw-mt-2">
            <table className="tw-w-full tw-border-collapse tw-text-sm">
              <thead>
                <tr className="tw-text-center">
                  <th className={TH_CLS} rowSpan={2}></th>
                  <th className={TH_CLS} rowSpan={2}>Location</th>
                  <th className={TH_CLS} colSpan={3}>Length (mm)</th>
                  <th className={TH_CLS} rowSpan={2}>Height (m)</th>
                  <th className={TH_CLS} rowSpan={2}>Open for</th>
                  <th className={TH_CLS} rowSpan={2}>Bracing Type</th>
                </tr>
                <tr className="tw-text-center">
                  <th className={TH_CLS}>Length</th>
                  <th className={TH_CLS}>From</th>
                  <th className={TH_CLS}>To</th>
                </tr>
              </thead>
              <tbody>
                {openWallData && openWallData.filter(item => item.area_id === area.id).map((item, index) => (
                  <tr key={index}>
                    <td className={TD_CLS}>
                      <ActionDropdown
                        align="end"
                        items={[
                          {
                            label: 'Edit',
                            icon: <FaEdit size={12} />,
                            onClick: () => editOpenWall(areaId, item)
                          },
                          { divider: true },
                          {
                            label: 'Delete',
                            icon: <FaTrashAlt size={12} />,
                            onClick: () => deleteOpenWall(areaId, item),
                            danger: true
                          }
                        ]}
                      />
                    </td>
                    <td className={TD_CLS}>{item.location}</td>
                    <td className={TD_CLS}>{item.length}</td>
                    <td className={TD_CLS}>{item.length_from}</td>
                    <td className={TD_CLS}>{item.length_to}</td>
                    <td className={TD_CLS}>{item.height}</td>
                    <td className={TD_CLS}>{item.open_for}</td>
                    <td className={TD_CLS}>{item.bracing_type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-mt-3 tw-mb-2">
            <Controller
              control={control}
              name={`bds1_open_walls_note_${area.id}`}
              render={({ field }) => (
                <TinymceEditor rollback={false}
                  height="30vh"
                  handleChange={field.onChange}
                  value={field.value}
                />
              )}
            />
          </div>
        </div>
      </Accordion.Item>

{/* 7. Roof */}
      <Accordion.Item eventKey="6" header="7. Roof">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-2">
            <div className="tw-col-span-2">
              <Controller
                control={control}
                name={`bds1_roof_by_pebsteel_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>by PEB Steel</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-x-2 tw-items-center">
                <div>Panel is:</div>
                <div className="tw-flex-1">
                  <input
                    placeholder="Panel is"
                    className={INPUT_CLS}
                    {...register(`bds1_roof_panel_is_${area.id}`)}
                  />
                </div>
              </div>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-x-2 tw-items-center">
                <div>Profile:</div>
                <div className="tw-flex-1">
                  <Controller
                    control={control}
                    name={`bds1_roof_profile_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={roofProfileOptions}
                        defaultValue={defaultRoofProfileOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_roof_profile_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-2">
            <div className="tw-col-span-2">
              <Controller
                control={control}
                name={`bds1_roof_by_others_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>by Others</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-col-span-10">
              <div className="tw-flex tw-gap-x-3 tw-items-center">
                <div>Color:</div>
                <div className="tw-flex-1">
                  <Controller
                    control={control}
                    name={`bds1_roof_color_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={colorOptions}
                        defaultValue={defaultRoofColorOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_roof_color_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-border tw-border-solid tw-border-slate-200 tw-py-2">
            <div className="tw-col-span-2">Insulation</div>
            <div className="tw-col-span-10">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-3">
                <div className="tw-col-span-8">
                  <div>
                    <Controller
                      control={control}
                      name={`bds1_roof_insulation_by_pebsteel_${area.id}`}
                      render={({ field }) => (
                        <label className={CHECK_LABEL_CLS}>
                          <input
                            type="checkbox"
                            className={CHECK_CLS}
                            checked={!!field.value}
                            onChange={(value) => field.onChange(value)}
                          />
                          <span>by PEB Steel</span>
                        </label>
                      )}
                    />
                  </div>
                  <div className="tw-flex tw-gap-x-4">
                    <div className="tw-flex-1">
                      <Controller
                        control={control}
                        name={`bds1_roof_name_${area.id}`}
                        render={() => (
                          <Select
                            closeMenuOnSelect={true}
                            options={roofInsulationOptions}
                            defaultValue={defaultRoofNameOption}
                            placeholder='Select...'
                            styles={SELECT_STYLES}
                            isClearable
                            onChange={selectedOption => setValue(`bds1_roof_name_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                          />
                        )}
                      />
                    </div>
                    <div className="tw-flex-1">
                      <div className="tw-flex tw-gap-x-2 tw-items-center">
                        <div>Thickness (mm):</div>
                        <div className="tw-flex-1">
                          <input
                            placeholder="Thickness (mm)"
                            className={INPUT_CLS}
                            {...register(`bds1_roof_insulation_thickness_${area.id}`)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tw-col-span-4">
                  <div>
                    <Controller
                      control={control}
                      name={`bds1_roof_insulation_by_others_${area.id}`}
                      render={({ field }) => (
                        <label className={CHECK_LABEL_CLS}>
                          <input
                            type="checkbox"
                            className={CHECK_CLS}
                            checked={!!field.value}
                            onChange={(value) => field.onChange(value)}
                          />
                          <span>by Others</span>
                        </label>
                      )}
                    />
                  </div>
                  <div className="tw-flex tw-gap-x-2 tw-items-center">
                    <div>Density:</div>
                    <div className="tw-flex-1">
                      <input
                        placeholder="Density"
                        className={INPUT_CLS}
                        {...register(`bds1_roof_insulation_density_${area.id}`)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <Controller
                  control={control}
                  name={`bds1_roof_insulation_note_${area.id}`}
                  render={({ field }) => (
                    <TinymceEditor rollback={false}
                      height="30vh"
                      handleChange={field.onChange}
                      value={field.value}
                    />
                  )}
                />
              </div>

            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-border tw-border-solid tw-border-slate-200 tw-py-2">
            <div className="tw-col-span-2">Skylight</div>
            <div className="tw-col-span-10">
              <div className="tw-flex tw-gap-x-2">
                <div className="tw-flex-1">
                  <Controller
                    control={control}
                    name={`bds1_roof_skylight_by_pebsteel_${area.id}`}
                    render={({ field }) => (
                      <label className={CHECK_LABEL_CLS}>
                        <input
                          type="checkbox"
                          className={CHECK_CLS}
                          checked={!!field.value}
                          onChange={(value) => field.onChange(value)}
                        />
                        <span>By Pebsteel</span>
                      </label>
                    )}
                  />
                </div>
                <div className="tw-flex-1">
                  <Controller
                    control={control}
                    name={`bds1_roof_skylight_single_layer_${area.id}`}
                    render={({ field }) => (
                      <label className={CHECK_LABEL_CLS}>
                        <input
                          type="checkbox"
                          className={CHECK_CLS}
                          checked={!!field.value}
                          onChange={(value) => field.onChange(value)}
                        />
                        <span>Single layer</span>
                      </label>
                    )}
                  />
                </div>
                <div className="tw-flex-1">
                  <Controller
                    control={control}
                    name={`bds1_roof_skylight_double_layer_${area.id}`}
                    render={({ field }) => (
                      <label className={CHECK_LABEL_CLS}>
                        <input
                          type="checkbox"
                          className={CHECK_CLS}
                          checked={!!field.value}
                          onChange={(value) => field.onChange(value)}
                        />
                        <span>Double layers</span>
                      </label>
                    )}
                  />
                </div>
                <div className="tw-w-1/3">
                  <Controller
                    control={control}
                    name={`bds1_roof_skylight_by_others_${area.id}`}
                    render={({ field }) => (
                      <label className={CHECK_LABEL_CLS}>
                        <input
                          type="checkbox"
                          className={CHECK_CLS}
                          checked={!!field.value}
                          onChange={(value) => field.onChange(value)}
                        />
                        <span>By Others</span>
                      </label>
                    )}
                  />
                </div>
              </div>
              <div className="tw-flex tw-gap-x-2">
                <div className="tw-flex-1">
                  <div>Width (mm):</div>
                  <input
                    placeholder="Width"
                    className={INPUT_CLS}
                    {...register(`bds1_roof_skylight_width_${area.id}`)}
                  />
                </div>
                <div className="tw-flex-1">
                  <div>Length (mm):</div>
                  <input
                    placeholder="Length"
                    className={INPUT_CLS}
                    {...register(`bds1_roof_skylight_length_${area.id}`)}
                  />
                </div>
                <div className="tw-flex-1">
                  <div>Thickness (mm):</div>
                  <input
                    placeholder="Thickness"
                    className={INPUT_CLS}
                    {...register(`bds1_roof_skylight_thickness_${area.id}`)}
                  />
                </div>
                <div className="tw-flex-1">
                  <div>Color:</div>
                  <input
                    placeholder="Color"
                    className={INPUT_CLS}
                    {...register(`bds1_roof_skylight_color_${area.id}`)}
                  />
                </div>
                <div className="tw-w-1/3">
                  <div>Description:</div>
                  <input
                    placeholder="Description"
                    className={INPUT_CLS}
                    {...register(`bds1_roof_skylight_desciption_${area.id}`)}
                  />
                </div>
              </div>
              <div className="tw-mt-3">
                <Controller
                  control={control}
                  name={`bds1_roof_skylight_note_${area.id}`}
                  render={({ field }) => (
                    <TinymceEditor rollback={false}
                      height="30vh"
                      handleChange={field.onChange}
                      value={field.value}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </Accordion.Item>

{/* 8. Wall */}
      <Accordion.Item eventKey="7" header="8. Wall">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-2">
            <div className="tw-col-span-2">
              <Controller
                control={control}
                name={`bds1_wall_by_pebsteel_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>by PEB Steel</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-x-2 tw-items-center">
                <div>Panel is:</div>
                <div className="tw-flex-1">
                  <input
                    placeholder="Panel is"
                    className={INPUT_CLS}
                    {...register(`bds1_wall_panel_is_${area.id}`)}
                  />
                </div>
              </div>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-x-2 tw-items-center">
                <div>Profile:</div>
                <div className="tw-flex-1">
                  <Controller
                    control={control}
                    name={`bds1_wall_profile_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={roofProfileOptions}
                        defaultValue={defaultWallProfileOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_wall_profile_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-2">
            <div className="tw-col-span-2">
              <Controller
                control={control}
                name={`bds1_wall_by_others_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>by Others</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-col-span-10">
              <div className="tw-flex tw-gap-x-3 tw-items-center">
                <div>Color:</div>
                <div className="tw-flex-1">
                  <Controller
                    control={control}
                    name={`bds1_wall_color_${area.id}`}
                    render={() => (
                      <Select
                        closeMenuOnSelect={true}
                        options={colorOptions}
                        defaultValue={defaultWallColorOption}
                        placeholder='Select...'
                        styles={SELECT_STYLES}
                        isClearable
                        onChange={selectedOption => setValue(`bds1_wall_color_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-border tw-border-solid tw-border-slate-200 tw-py-2">
            <div className="tw-col-span-2">Insulation</div>
            <div className="tw-col-span-10">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-3">
                <div className="tw-col-span-8">
                  <div>
                    <Controller
                      control={control}
                      name={`bds1_wall_insulation_by_pebsteel_${area.id}`}
                      render={({ field }) => (
                        <label className={CHECK_LABEL_CLS}>
                          <input
                            type="checkbox"
                            className={CHECK_CLS}
                            checked={!!field.value}
                            onChange={(value) => field.onChange(value)}
                          />
                          <span>by PEB Steel</span>
                        </label>
                      )}
                    />
                  </div>
                  <div className="tw-flex tw-gap-x-4">
                    <div className="tw-flex-1">
                      <Controller
                        control={control}
                        name={`bds1_wall_name_${area.id}`}
                        render={() => (
                          <Select
                            closeMenuOnSelect={true}
                            options={roofInsulationOptions}
                            defaultValue={defaultWallNameOption}
                            placeholder='Select...'
                            styles={SELECT_STYLES}
                            isClearable
                            onChange={selectedOption => setValue(`bds1_wall_name_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                          />
                        )}
                      />
                    </div>
                    <div className="tw-flex-1">
                      <div className="tw-flex tw-gap-x-2 tw-items-center">
                        <div>Thickness (mm):</div>
                        <div className="tw-flex-1">
                          <input
                            placeholder="Thickness (mm)"
                            className={INPUT_CLS}
                            {...register(`bds1_wall_insulation_thickness_${area.id}`)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tw-col-span-4">
                  <div>
                    <Controller
                      control={control}
                      name={`bds1_wall_insulation_by_others_${area.id}`}
                      render={({ field }) => (
                        <label className={CHECK_LABEL_CLS}>
                          <input
                            type="checkbox"
                            className={CHECK_CLS}
                            checked={!!field.value}
                            onChange={(value) => field.onChange(value)}
                          />
                          <span>by Others</span>
                        </label>
                      )}
                    />
                  </div>
                  <div className="tw-flex tw-gap-x-2 tw-items-center">
                    <div>Density:</div>
                    <div className="tw-flex-1">
                      <input
                        placeholder="Density"
                        className={INPUT_CLS}
                        {...register(`bds1_wall_insulation_density_${area.id}`)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <Controller
                  control={control}
                  name={`bds1_wall_insulation_note_${area.id}`}
                  render={({ field }) => (
                    <TinymceEditor rollback={false}
                      height="30vh"
                      handleChange={field.onChange}
                      value={field.value}
                    />
                  )}
                />
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-border tw-border-solid tw-border-slate-200 tw-py-2">
            <div className="tw-col-span-2">Wall light</div>
            <div className="tw-col-span-10">
              <div className="tw-grid tw-grid-cols-12 tw-gap-x-2">
                <div className="tw-col-span-8">
                  <Controller
                    control={control}
                    name={`bds1_wall_light_by_pebsteel_${area.id}`}
                    render={({ field }) => (
                      <label className={CHECK_LABEL_CLS}>
                        <input
                          type="checkbox"
                          className={CHECK_CLS}
                          checked={!!field.value}
                          onChange={(value) => field.onChange(value)}
                        />
                        <span>By Pebsteel</span>
                      </label>
                    )}
                  />
                </div>
                <div className="tw-col-span-4">
                  <Controller
                    control={control}
                    name={`bds1_wall_light_by_others_${area.id}`}
                    render={({ field }) => (
                      <label className={CHECK_LABEL_CLS}>
                        <input
                          type="checkbox"
                          className={CHECK_CLS}
                          checked={!!field.value}
                          onChange={(value) => field.onChange(value)}
                        />
                        <span>By Others</span>
                      </label>
                    )}
                  />
                </div>
              </div>
              <div className="tw-flex tw-gap-x-2">
                <div className="tw-flex-1">
                  <div>Width (mm):</div>
                  <input
                    placeholder="Width"
                    className={INPUT_CLS}
                    {...register(`bds1_wall_light_width_${area.id}`)}
                  />
                </div>
                <div className="tw-flex-1">
                  <div>Length (mm):</div>
                  <input
                    placeholder="Length"
                    className={INPUT_CLS}
                    {...register(`bds1_wall_light_length_${area.id}`)}
                  />
                </div>
                <div className="tw-flex-1">
                  <div>Thickness (mm):</div>
                  <input
                    placeholder="Thickness"
                    className={INPUT_CLS}
                    {...register(`bds1_wall_light_thickness_${area.id}`)}
                  />
                </div>
                <div className="tw-flex-1">
                  <div>Color:</div>
                  <input
                    placeholder="Color"
                    className={INPUT_CLS}
                    {...register(`bds1_wall_light_color_${area.id}`)}
                  />
                </div>
                <div className="tw-w-1/3">
                  <div>Description:</div>
                  <input
                    placeholder="Description"
                    className={INPUT_CLS}
                    {...register(`bds1_wall_light_description_${area.id}`)}
                  />
                </div>
              </div>
              <div className="tw-mt-3">
                <Controller
                  control={control}
                  name={`bds1_wall_light_note_${area.id}`}
                  render={({ field }) => (
                    <TinymceEditor rollback={false}
                      height="30vh"
                      handleChange={field.onChange}
                      value={field.value}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </Accordion.Item>

{/* 9. Sheeting Angle, Gable Angle, Eave Angle (If sheeting by others) */}
      <Accordion.Item eventKey="8" header="9. Sheeting Angle, Gable Angle, Eave Angle (If sheeting by others)">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-2">
            <div className="tw-col-span-8">
              <Controller
                control={control}
                name={`bds1_sheeting_angle_by_pebsteel_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>By Pebsteel</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-col-span-4">
              <Controller
                control={control}
                name={`bds1_sheeting_angle_by_others_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>By Others</span>
                  </label>
                )}
              />
            </div>
          </div>
          <div>
            <Controller
              control={control}
              name={`bds1_sheeting_angle_note_${area.id}`}
              render={({ field }) => (
                <TinymceEditor rollback={false}
                  height="30vh"
                  handleChange={field.onChange}
                  value={field.value}
                />
              )}
            />
          </div>
        </div>
      </Accordion.Item>

{/* 10. Eave Condition */}
      <Accordion.Item eventKey="9" header="10. Eave Condition">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-flex tw-gap-x-4 tw-mb-2">
            <div className="tw-flex-1">
              <Controller
                control={control}
                name={`bds1_eave_condition_gutter_downspouts_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>Gutters &amp; Downspouts,</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-flex-1">
              <Controller
                control={control}
                name={`bds1_eave_condition_trim_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>Eave Trim,</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-flex-1"></div>
            <div className="tw-flex-1"></div>
          </div>
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div className="tw-flex-1">
              <Controller
                control={control}
                name={`bds1_eave_condition_curved_projection_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>Curved Eave with projection,</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-flex-1">
              <Controller
                control={control}
                name={`bds1_eave_condition_w_o_gutters_downspouts_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>w/o Gutters &amp; Downspouts,</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-flex-1">
              <Controller
                control={control}
                name={`bds1_eave_condition_w_valley_gutters_downspouts_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>w/Valley Gutters &amp; Downspouts,</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-justify-between">
                <div>Downspouts</div>
                <Controller
                  control={control}
                  name={`bds1_eave_condition_downspouts_meta_${area.id}`}
                  render={({ field }) => (
                    <label className={CHECK_LABEL_CLS}>
                      <input
                        type="checkbox"
                        className={CHECK_CLS}
                        checked={!!field.value}
                        onChange={(value) => field.onChange(value)}
                      />
                      <span>Metal</span>
                    </label>
                  )}
                />
                <Controller
                  control={control}
                  name={`bds1_eave_condition_downspouts_pvc_${area.id}`}
                  render={({ field }) => (
                    <label className={CHECK_LABEL_CLS}>
                      <input
                        type="checkbox"
                        className={CHECK_CLS}
                        checked={!!field.value}
                        onChange={(value) => field.onChange(value)}
                      />
                      <span>PVC</span>
                    </label>
                  )}
                />
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-x-2">
            <div className="tw-flex-1">
              <Controller
                control={control}
                name={`bds1_eave_condition_curved_projection2_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>Curved Eave w/o projection,</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-flex-1">
              <Controller
                control={control}
                name={`bds1_eave_condition_w_o_gutters_downspouts2_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>w/o Gutters &amp; Downspouts,</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-flex-1">
              <Controller
                control={control}
                name={`bds1_eave_condition_w_valley_gutters_downspouts2_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>w/Valley Gutters &amp; Downspouts,</span>
                  </label>
                )}
              />
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-justify-between">
                <div>Downspouts</div>
                <Controller
                  control={control}
                  name={`bds1_eave_condition_downspouts_meta2_${area.id}`}
                  render={({ field }) => (
                    <label className={CHECK_LABEL_CLS}>
                      <input
                        type="checkbox"
                        className={CHECK_CLS}
                        checked={!!field.value}
                        onChange={(value) => field.onChange(value)}
                      />
                      <span>Metal</span>
                    </label>
                  )}
                />
                <Controller
                  control={control}
                  name={`bds1_eave_condition_downspouts_pvc2_${area.id}`}
                  render={({ field }) => (
                    <label className={CHECK_LABEL_CLS}>
                      <input
                        type="checkbox"
                        className={CHECK_CLS}
                        checked={!!field.value}
                        onChange={(value) => field.onChange(value)}
                      />
                      <span>PVC</span>
                    </label>
                  )}
                />
              </div>
            </div>
          </div>
          <div className="tw-mt-2">
            <Controller
              control={control}
              name={`bds1_eave_condition_note_${area.id}`}
              render={({ field }) => (
                <TinymceEditor rollback={false}
                  height="30vh"
                  handleChange={field.onChange}
                  value={field.value}
                />
              )}
            />
          </div>
        </div>
      </Accordion.Item>

{/* 11. Wall Trim Colors */}
      <Accordion.Item eventKey="10" header="11. Wall Trim Colors">
        <div className={SECTION_BODY_CLS}>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-mb-3">
            <div className="tw-col-span-4">
              <div>Color of gutters , down spouts , Eave trim :</div>
              <Controller
                control={control}
                name={`bds1_wall_trim_colors_${area.id}`}
                render={() => (
                  <Select
                    closeMenuOnSelect={true}
                    options={colorOptions}
                    defaultValue={defaultWallTrimColorGutterOption}
                    placeholder='Select...'
                    styles={SELECT_STYLES}
                    isClearable
                    onChange={selectedOption => setValue(`bds1_wall_trim_colors_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                  />
                )}
              />
            </div>
            <div className="tw-col-span-8">
              <Controller
                control={control}
                name={`bds1_wall_trim_colors_gutters_note_${area.id}`}
                render={({ field }) => (
                  <TinymceEditor rollback={false}
                    height="30vh"
                    handleChange={field.onChange}
                    value={field.value}
                  />
                )}
              />
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-x-4">
            <div className="tw-col-span-4">
              <div>Color of other flashing, trim:</div>
              <Controller
                control={control}
                name={`bds1_wall_trim_colors_others_${area.id}`}
                render={() => (
                  <Select
                    closeMenuOnSelect={true}
                    options={colorOptions}
                    defaultValue={defaultWallTrimColorOtherOption}
                    placeholder='Select...'
                    styles={SELECT_STYLES}
                    isClearable
                    onChange={selectedOption => setValue(`bds1_wall_trim_colors_others_${area.id}`, selectedOption ? selectedOption.value : null, {shouldValidate: true})}
                    menuPortalTarget={document.body}
                  />
                )}
              />
            </div>
            <div className="tw-col-span-8">
              <Controller
                control={control}
                name={`bds1_wall_trim_colors_flashing_note_${area.id}`}
                render={({ field }) => (
                  <TinymceEditor rollback={false}
                    height="30vh"
                    handleChange={field.onChange}
                    value={field.value}
                  />
                )}
              />
            </div>
          </div>
        </div>
      </Accordion.Item>
    </Accordion>
  )
};

BDS1.propTypes = {
  data: PropTypes.object.isRequired,
  openWallData: PropTypes.object.isRequired,
  newOpenWall: PropTypes.func.isRequired,
  editOpenWall: PropTypes.func.isRequired,
  deleteOpenWall: PropTypes.func.isRequired
}

export default BDS1;
